import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSignOut } from '@fortawesome/pro-light-svg-icons'

import isMobileBrowser from 'is-mobile'

import { Button } from '@domain-group/suit-theme'

import { useSetState } from '@domain-group/react-hooks'

import handleCallbackAction from '@functions/handleCallbackAction'

const isMobile = isMobileBrowser()

const defaultState = {
  loading: false,
}

type SetState = (state: Partial<typeof defaultState>) => void

type LoginAsEntityUserParams = {
  loginFn: VoidFunction,
  requestOptions?: object,
  setState: SetState,
}

const loginAsEntityUser = (params: LoginAsEntityUserParams) => {
  const { loginFn, setState, requestOptions } = params

  setState({ loading: true })

  const loginAsEntityUserPayload = {
    callbacks: {
      action: loginFn,
      afterAction: () => setState({ loading: false }),
      buildActionParams: () => [requestOptions],
    },
    shouldRedirect: true,
    toastText: 'Logged In',
  }

  // @ts-expect-error TS2345
  handleCallbackAction(loginAsEntityUserPayload)
}
type LoginAsEntityButtonProps = {
  callbacks: {
    loginAsEntity: VoidFunction,
  },
  children: React.ReactNode,
  requestOptions?: object,
}

const LoginAsEntityButton = (props: LoginAsEntityButtonProps) => {
  const {
    callbacks: { loginAsEntity },
    children,
    requestOptions,
    ...restProps
  } = props

  const [state, setState] = useSetState(defaultState)
  const { loading } = state

  return (
    <Button
      buttonStyle="secondaryEdit"
      icon={<FontAwesomeIcon icon={faSignOut} />}
      loading={loading}
      onClick={() => loginAsEntityUser({
        loginFn: loginAsEntity,
        requestOptions,
        setState,
      })}
      size="medium"
      //@ts-expect-error
      width="auto"
      {...restProps}
    >
      {isMobile ? 'Login' : children}
    </Button>
  )
}

export default LoginAsEntityButton
